var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-specialLuggage",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 8.875C4.69643 13 4 19 4 19C4 19 10 18.3036 14.125 14.125C18.25 9.94643 19 4 19 4C19 4 13 4.69643 8.875 8.875Z",
    stroke: "#7E8A96",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9V10.5328C9 11.4526 9.54 12.3212 10.5 12.781C11.46 13.2409 12 14.1095 12 15.0292V15.5",
    stroke: "#7E8A96",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5V7.9927C12 8.91241 12.54 9.78102 13.5 10.2409C14.46 10.7007 15 11.5693 15 12.4891V13",
    stroke: "#7E8A96",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialLuggage);
export default __webpack_public_path__ + "static/media/specialLuggage.0567f680.svg";
export { ForwardRef as ReactComponent };